import { apiSlice } from "app/apiSlice";
import loginReducer from "modules/Login/reducers";

import brandsReducer from "../modules/Brands/reducers";
import campaignsReducer from "../modules/Campaigns/reducers";
import creatorsReducer from "../modules/Creators/reducers";
import dashboardReducer from "../modules/Dashboard/reducers";

import loadingReducer from "./loadingReducer";
import type { Reducer } from "@reduxjs/toolkit";

// Legacy reducers with proper types to satisfy configureStore
export const rootReducer = {
  loading: loadingReducer as Reducer,
  brands: brandsReducer as Reducer,
  creators: creatorsReducer as Reducer,
  campaigns: campaignsReducer as Reducer,
  dashboard: dashboardReducer as Reducer,
  login: loginReducer as Reducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
};
